import React from "react";
import { render } from "react-dom";

class AlACarte extends React.Component {
     constructor(props){
        super(props);
        this.state={
            loading:false,
            rows: [{}]       
        }
    }
 /*  state = {
    rows: [{}]
  }; */
  handleChange = idx => e => {
    const { name, value } = e.target;
    const rows = [...this.state.rows];
    rows[idx] = {
      [name]: value
    };
    this.setState({
      rows
    });
  };
  handleAddRow = () => {
    const item = {
      name: "",
      price: "",allDay: "",mon: "",tue: "",
      wed: "",fri: "",sat:"",
    };
    this.setState({
      rows: [...this.state.rows, item]
    });
  };
  handleRemoveRow = () => {
    this.setState({
      rows: this.state.rows.slice(0, -1)
    });
  };
  handleRemoveSpecificRow = (idx) => () => {
    const rows = [...this.state.rows]
    rows.splice(idx, 1)
    this.setState({ rows })
  }
  render() {
    return (
      <div>
        <div className="container">
          <div className="row clearfix">
            <div className="col-md-12 column">
            <button onClick={this.handleAddRow} class="menubtn btn-primary pull-right">
                <i class="fa fa-plus"></i></button>
              <table
                className="table-bordered table-hover"
                style={{width: '85%;'}}
                id="tab_logic"
              >
                <thead style={{backgroundColor: 'rgb(210, 215, 212)'}}>
                  <tr>                         
                    <th style={{width: '10%',textAlign: 'center'}}> Item Name </th>
                    <th style={{width: '5%',textAlign: 'center'}}> Price </th>
                    <th style={{width: '20%',textAlign: 'center'}}> Available On </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.rows.map((item, idx) => (
                    <tr id="addr0" key={idx}>
                      <td>
                        <input
                          type="text"
                          name="name"
                          value={this.state.rows[idx].name}
                          onChange={this.handleChange(idx)}
                          className="form-control"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          name="price"
                          value={this.state.rows[idx].price}
                          onChange={this.handleChange(idx)}
                          className="form-control"
                        />
                      </td>
                      <td>
                      <div className="form-group">
                          <input type="checkbox" 
                           name="allDay"
                           value={this.state.rows[idx].allDay}
                           onChange={this.handleChange(idx)}
                          style={{marginLeft:'20px'}}/><span>All Day</span>
                          <input type="checkbox"
                           name="mon"
                           value={this.state.rows[idx].mon}
                           onChange={this.handleChange(idx)} 
                          style={{marginLeft:'30px'}} /><span>Mon</span>
                          <input type="checkbox"
                           name="tue"
                           value={this.state.rows[idx].tue}
                           onChange={this.handleChange(idx)}
                          style={{marginLeft:'30px'}}/><span>Tue</span>
                          <input type="checkbox"
                           name="wed"
                           value={this.state.rows[idx].wed}
                           onChange={this.handleChange(idx)}
                           style={{marginLeft:'30px'}}/><span>Wed</span>
                          <input type="checkbox" 
                           name="thu"
                           value={this.state.rows[idx].thu}
                           onChange={this.handleChange(idx)}
                          style={{marginLeft:'30px'}}/><span>Thu</span>
                          <input type="checkbox" 
                           name="fri"
                           value={this.state.rows[idx].fri}
                           onChange={this.handleChange(idx)}
                          style={{marginLeft:'30px'}}/><span>Fri</span>
                          <input type="checkbox"
                           name="sat"
                           value={this.state.rows[idx].sat}
                           onChange={this.handleChange(idx)}
                           style={{marginLeft:'30px'}}/><span>Sat</span>
                        </div>
                      </td>
                     {/*  <td>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={this.handleRemoveSpecificRow(idx)}
                        >
                          Remove
                        </button>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <button onClick={this.handleAddRow} className="btn btn-primary">
                Add Row
              </button> */}
              {/* <button
                onClick={this.handleRemoveRow}
                className="btn btn-danger float-right"
              >
                Delete Last Row
              </button> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AlACarte




// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/alAcarte.jsx